module.exports = __webpack_public_path__ + "static/media/innovation-animate.0b793c9e.svg";